import React from 'react';
import { Table, Icon, Tooltip } from '@weezevent/nacre';
import TableError from './TableError';
import css from '../../../styles.module.css';
import { useTranslation } from 'react-i18next';

export default function Row({ index, onPaste, onChange, attendee, sendMail }) {
    const { t } = useTranslation();
    const isValid = React.useMemo(() => {
        if (!attendee.lastname && !attendee.firstname && !attendee.quantity && !attendee.email) {
            return true;
        }
        if (!sendMail) {
            return attendee.valid;
        }
        return attendee.valid && attendee.email;
    }, [attendee, sendMail]);

    return (
        <Table.Row name="attendees">
            <Table.Cell content={index + 1} />
            <Table.Cell
                content={<input name="lastname" onPaste={onPaste} data-id={index} value={attendee.lastname} onChange={e => onChange('lastname', e.target.value)} type="text" />}
            />
            <Table.Cell
                content={<input name="firstname" onPaste={onPaste} data-id={index} value={attendee.firstname} onChange={e => onChange('firstname', e.target.value)} type="text" />}
            />
            <Table.Cell
                content={
                    <div className={css['quantity-input']}>
                        <input
                            name="quantity"
                            onPaste={onPaste}
                            data-id={index}
                            value={attendee.quantity}
                            min={1}
                            step={1}
                            max={50} // Max value to prevent sending too many orders with too many attendees to Pyvar
                            onChange={e => onChange('quantity', e.target.value)}
                            type="number"
                        />
                        {(!attendee.quantity || isNaN(attendee.quantity) || parseInt(attendee.quantity) < 1) && (attendee.lastname || attendee.firstname || attendee.email) && (
                            <Tooltip triggerOnHover title={t('ticket.common.validator_quantity')}>
                                <Icon error name="message-warning" label="test" color="target" />
                            </Tooltip>
                        )}
                    </div>
                }
            />
            <Table.Cell
                content={
                    <div className={css['email-input']}>
                        <input
                            className={`${attendee.valid ? css['valid'] : css['invalid']}`}
                            name="email"
                            onPaste={onPaste}
                            data-id={index}
                            value={attendee.email}
                            onChange={e => onChange('email', e.target.value)}
                            type="email"
                        />
                        {!isValid && <TableError />}
                    </div>
                }
            />
        </Table.Row>
    );
}
